import Lines from '../components/common/Lines';
import ProgressScroll from '../components/common/ProgressScroll';
import Cursor from '../components/common/cusor';
import LoadingScreen from '../components/common/loader';
import Footer from '../components/common/Footer';
import Navbar from '../components/common/Navbar';
import Marq2 from '../components/common/Marq2';
import { Helmet } from 'react-helmet';
import Header from '../components/home/Header';
import Clients from '../components/common/Clients';
import Marq from '../components/home/Marq';
import About from '../components/home/About';
import Portfolio from '../components/home/Portfolio';
import Testimonials from '../components/home/Testimonials';
import Skills from '../components/home/Skills';
import Intro from '../components/home/Intro';
import WOW from 'wowjs';
import gsap from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
// import { ScrollSmoother } from 'gsap-trial/ScrollSmoother';

import { useGSAP } from '@gsap/react';
import { useEffect, useRef } from 'react';
gsap.registerPlugin(useGSAP, ScrollTrigger);

export default function HomePersonal() {
  const main = useRef();
  const smoother = useRef();

  // Add effect to reset scroll position on page load
  useEffect(() => {
    // Scroll to top when component mounts
    window.scrollTo(0, 0);
    
    // Also prevent any hash-based scrolling
    if (window.location.hash) {
      // If there's a hash in the URL, remove it without reloading the page
      window.history.replaceState("", document.title, window.location.pathname + window.location.search);
    }

    // Prevent browser from restoring scroll position
    if ('scrollRestoration' in window.history) {
      window.history.scrollRestoration = 'manual';
    }

    return () => {
      // Reset to auto when component unmounts
      if ('scrollRestoration' in window.history) {
        window.history.scrollRestoration = 'auto';
      }
    };
  }, []);

  useEffect(() => {
    const loadScript = (src) => {
      return new Promise((resolve, reject) => {
        const script = document.createElement('script');
        script.src = src;
        script.async = true;

        script.onload = () => {
          resolve(true);
        };

        script.onerror = () => {
          reject(new Error(`Failed to load ${src}`));
        };

        document.body.appendChild(script);
      });
    };

    // Load scripts in sequence
    loadScript('/assets/js/gsap.min.js')
      .then(() => loadScript('/assets/js/ScrollTrigger.min.js'))
      .then(() => loadScript('/assets/js/ScrollSmoother.min.js'))
      .then(() => loadScript('/assets/js/smoother-script.js'))
      .catch((error) => {
        console.error(error.message);
      });

  }, []);
  
  useEffect(() => {
    // Wait for document to be fully loaded
    if (typeof window !== 'undefined') {
      // Make sure WOW is available
      if (WOW && WOW.WOW) {
        const wow = new WOW.WOW({
          animateClass: 'animated',
          offset: 100,
        });
        wow.init();
      }
    }
  }, []);
  
  return (
    <>
      <Helmet>
        <title>NarrativeOS - TBD</title>
        <link rel="icon" href="/assets/imgs/favicon.ico" />
        <link rel="shortcut icon" href="/assets/imgs/favicon.ico" />
        <link rel="stylesheet" type="text/css" href="/assets/css/plugins.css" />
        <link rel="stylesheet" type="text/css" href="/assets/css/style.css" />

        <link
          rel="stylesheet"
          type="text/css"
          href="https://fonts.googleapis.com/css?family=Poppins:100,200,300,400,500,600,700,800,900&display=swap"
        />
        <link
          rel="stylesheet"
          type="text/css"
          href="https://fonts.googleapis.com/css2?family=Plus+Jakarta+Sans:wght@200;300;400;500;600;700&display=swap"
        />
        <script src="/assets/js/ScrollTrigger.min.js" defer />
        <script src="/assets/js/ScrollSmoother.min.js" defer />
        <script defer src="/assets/js/gsap.min.js"></script>
        <script defer src="/assets/js/splitting.min.js"></script>
        <script defer src="/assets/js/isotope.pkgd.min.js"></script>
        <script defer src="/assets/js/plugins.js"></script>
        <script defer src="/assets/js/TweenMax.min.js"></script>
        <script defer src="/assets/js/charming.min.js"></script>
        <script defer src="/assets/js/countdown.js"></script>
      </Helmet>
      <div className="home-personal">
        <LoadingScreen />
        <Cursor />
        <ProgressScroll />
        <Lines />
        <Navbar />
        <div id="smooth-wrapper" ref={main}>
          <div id="smooth-content">
            <main className="main-bg o-hidden">
              <Header />
              
              <Marq />
              <About />
              <Portfolio />
              {/* <Skills /> */}
              <Clients />
              <Testimonials />
              <Intro />
              <Marq2 />
            </main>
            <Footer />
          </div>
        </div>
      </div>
    </>
  );
}
